import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { MemberRolesResponseDto, ResponseDto } from "@mimber/schema"
import { memberRolesKeys } from "../roles.utils"

/**
 * Organization-specific hook for fetching a member's roles (direct + group-inherited)
 * Can only be used in mimber-organization app
 */
export const useMemberRoles = (
  memberUuid: string,
  options?: UseQueryOptions<ResponseDto<MemberRolesResponseDto>, Error>
): UseQueryResult<ResponseDto<MemberRolesResponseDto>, Error> => {
  guardAppUsage("mimber-organization", "useMemberRoles")

  const { server } = useServerContext()

  return useQuery({
    queryKey: memberRolesKeys.findByMember(memberUuid),
    queryFn: async () => {
      const response = await server.get<ResponseDto<MemberRolesResponseDto>>(
        `members/${memberUuid}/roles`
      )
      return response.data
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!memberUuid,
    ...options,
  })
}
